module.exports = __webpack_public_path__ + "static/media/man.bread.pic.feda1faa.png";